import { MIME_TYPE_FORM_DATA_MULTIPART } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";

export interface AccidentReportImportRow {
  licensePlate: string;
  damageNumber: string;
}

export interface AccidentReportImportResult {
  importedCount: number;
  alreadyHasAccidentReport: AccidentReportImportRow[];
  notFound: AccidentReportImportRow[];
}

export const importAccidentReports = async (
  file: File,
): Promise<AccidentReportImportResult> => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance
    .post(`/data-management/import-accident-report-placeholders`, formData, {
      headers: { "Content-Type": MIME_TYPE_FORM_DATA_MULTIPART },
    })
    .then((response) => response.data);
};
